var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meterial-input-page"},[_c('a-row',{attrs:{"gutter":13}},[_c('a-col',{attrs:{"span":24}},[_c('busStandardTeamConfig-modal',{on:{"chooseDepart":_vm.handleChooseDepart}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }